import { RenewBindMdl } from './../Models/RenewBindMdl';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { TPLProposal } from '../Models/TPLProposal';
import * as CryptoJS from 'crypto-js';
import { environment } from '../environments/environment';


@Injectable()
export class renewalProposalService {
    private subject = new Subject<TPLProposal>();
    private bindsubject = new Subject<RenewBindMdl>();
    private proposalObj: TPLProposal;
    private bindObj: RenewBindMdl;

    saveRenewalProposalObj(ProposalObj: TPLProposal) {

        //sessionStorage.setItem("TplObj", JSON.stringify(ProposalObj))
        sessionStorage.setItem("TplObj", this.EncriptObject(JSON.stringify(ProposalObj)))
    }
    getRenewalProposalObj(): TPLProposal {
        //this.proposalObj = JSON.parse(sessionStorage.getItem("TplObj"));
        this.proposalObj = JSON.parse(this.DecriptObject(sessionStorage.getItem("TplObj")));
        return this.proposalObj;
    }
    saveRenewalBindObj(bindObj: RenewBindMdl) {
        //sessionStorage.setItem("TplBindObj", JSON.stringify(bindObj))
        sessionStorage.setItem("TplBindObj", this.EncriptObject(JSON.stringify(bindObj)));
    }
    getRenewalBindObj(): RenewBindMdl {
        //this.bindObj = JSON.parse(sessionStorage.getItem("TplBindObj"));
        this.bindObj = JSON.parse(this.DecriptObject(sessionStorage.getItem("TplBindObj")));
        return this.bindObj;
    }

    sendRenewProposal(ProposalObj: TPLProposal) {
        this.subject.next(ProposalObj);

    }
    sendRenewBindInfo(bindObj: RenewBindMdl) {
        this.bindsubject.next(bindObj);
    }

    clearRenewProposal() {
        this.subject.next();
    }

    clearRenewBindInfo() {
        this.bindsubject.next();
    }

    getRenewProposal(): Observable<TPLProposal> {
        return this.subject.asObservable();
    }

    getRenewBindInfo(): Observable<RenewBindMdl> {
        return this.bindsubject.asObservable();
    }

    EncriptObject(CipherText: string): string {
        var param = environment;           
        if (!param.St.StatusDesc) {
            throw new Error("Encryption key is not initialized.");
        }

        var EncriptCipherText = CryptoJS.AES.encrypt(JSON.stringify(CipherText), param.St.StatusDesc).toString();
        return EncriptCipherText;
    }

    DecriptObject(CipherText: string): string {
        var param = environment;           
        if (!param.St.StatusDesc) {
            throw new Error("Encryption key is not initialized.");
        }
        
        var CipherTextbytes = CryptoJS.AES.decrypt(CipherText, param.St.StatusDesc);
        var DeCriptCipherText = JSON.parse(CipherTextbytes.toString(CryptoJS.enc.Utf8));
        return DeCriptCipherText;

    }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/renewalProposalService.ts